import { lazy } from 'react';
 

export const routes = [
    {
        path: "/Messages",
        exact: true,
        component: lazy(() => import("./components/Messages")),
        name: "Messages"
    }
];